import React from "react";
import "./OrderStatusTableAICard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";

export const OrderStatusTableAICard = ({
  message,
  title,
  onStatusClick,
}) => {
  const d = new Date(message.timestamp || Date.now());
  const day = d.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  // Extract order status data from message
  const statusData = message.orderStatusData || [];
  const headerText =
    message.headerText ||
    " Here is your orders count with all order status.";
  const subText =
    message.subText || "Select any status to see all orders associated to it.";

  const handleStatusClick = (status) => {
    if (onStatusClick) {
      onStatusClick(status);
    }
  };

  return (
    <div className="order-status-table-ai-card ai-left">
      <div className="order-status-table-ai-header">
        <img
          src={aiChatlogo}
          alt="Axon AI"
          className="order-status-table-ai-logo"
        />
        <div className="order-status-table-ai-title">
          <span>{title || "GDS.ai Axon"}</span>
          <div className="order-status-table-ai-time">{`${day} ${time}`}</div>
        </div>
      </div>
      <div className="order-status-table-ai-bubble">
        <div className="order-status-table-ai-content">
          <p className="order-status-header-text">
            <span className="checkmark-icon">✅</span> {headerText}
          </p>
          <p className="order-status-sub-text">
            <span className="pointer-icon">👆</span> {subText}
          </p>

          <div className="order-status-table-wrapper">
            <table className="order-status-table">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>No. of Orders</th>
                </tr>
              </thead>
              <tbody>
                {statusData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <span
                        className="status-link"
                        onClick={() => handleStatusClick(item)}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>{item.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
